export default{ 
	cityList:[], 
	cityInfo:{},
	urlPath:{
		'initReportImg':'/iotmonitor-server/monitor/overview/project/data/getProjectMonitorReport',
		'initBaseInfo':'/iotmonitor-server/monitor/overview/project/data/getProjectBaseInfo',
		'initProInfo':'/iotmonitor-server/monitor/overview/project/data/listEquipListByProjectCode',
		'initServiceInfo':'/iotmonitor-server/monitor/overview/project/data/listNearFutureOrderServiceByProject',
		'initOnlineInfo':'/iotmonitor-server/monitor/overview/project/data/listOnlineServiceByProject',
		'initOffOnlineInfo':'/iotmonitor-server/monitor/overview/project/data/listOfflineServiceByProject',
		'initWaterUseInfo':'/iotmonitor-server/monitor/overview/project/data/listWaterUserInfoByProject',
		'initFilterInfo':'/iotmonitor-server/monitor/overview/project/data/getFilterChangeInfoByProject',
		'initReportImg':'/iotmonitor-server/monitor/overview/equip/data/getEquipMonitorReport',
		'initBaseInfo':'/iotmonitor-server/monitor/overview/equip/data/getEquipBaseInfo',
		'initFilterInfo':'/iotmonitor-server/monitor/overview/equip/data/getFilterChangeInfoByEquip',
		'initFilterEquipInfo':'/iotmonitor-server/monitor/overview/equip/data/getFilterPercentByEquip',
		'initOnlineInfo':'/iotmonitor-server/monitor/overview/equip/data/listOnlineServiceByEquip',
		'initOffOnlineInfo':'/iotmonitor-server/monitor/overview/equip/data/listOfflineServiceByEquip',
		'initWaterUseInfo':'/iotmonitor-server/monitor/overview/equip/data/listWaterUserInfoByEquip',
		'initMicroInfo':'/iotmonitor-server/monitor/overview/equip/data/getMicroInfoByEquip',
		'initServiceInfo':'/iotmonitor-server/monitor/overview/equip/data/listNearFutureOrderServiceByEquip',
	}
}


//////////////////
// WEBPACK FOOTER
// ./store/state.js
// module id = null
// module chunks = 